import { Button, Typography, useTheme } from "@mui/material";
import React, { ReactElement } from "react";
import HamMenuIcon from "../../../../../media/images/icons/hambergerMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { blueGrey, grey } from "@mui/material/colors";

interface Props {
  icon: ReactElement;
  title: string;
  path: string;
  handleClick: (index: number) => void;
}

export default function TabItem({ icon, title, path, handleClick }: Props) {
  const theme = useTheme();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <Button
      onClick={() => {
        if (path === "") {
          return handleClick(1);
        }
        navigate(path);
      }}
      sx={{
        // border: "1px solid gray",
        flex: "1",
        borderRadius: "0px",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        flexDirection: "column",
        // borderColor: `${theme.palette.secondary.main} !important`,
        // backgroundColor: `${theme.palette.secondary.light} !important`,
        "& .MuiTouchRipple-root": {
          color: `${theme.palette.secondary.main} !important`,
          borderWidth: "0px !important",
        },
        "& .MuiButtonBase-root": {
          color: `${theme.palette.secondary.main} !important`,
          borderWidth: "0px !important",
        },
      }}
    >
      {icon}
      <Typography
        noWrap
        sx={{
          fontSize: "12px",
          fontWeight: "700",
          color: path === pathname ? "secondary.main" : blueGrey[400],
        }}
      >
        {title}
      </Typography>
    </Button>
  );
}
